module.exports = __webpack_public_path__ + "img/home-image4.6a3df835.jpg";